export default __webpack_public_path__ + "static/media/790651385163153408.be21ddf1.png";